import { Icon } from "@/components/icon";
import type { NavProps } from "@/components/nav";
import { GLOBAL_CONFIG } from "@/global-config";

export const frontendNavData: NavProps["data"] = [
  {
    items: [
      {
        title: "sys.nav.dashboard",
        path: "/dashboard",
        icon: <Icon icon="local:suc-app-window-pie-chart" size={20} />,
      },
      {
        title: "sys.nav.clients",
        path: "/clients",
        icon: <Icon icon="local:suc-app-window-code" size={20} />,
      },
      {
        title: "sys.nav.orders",
        path: "/orders",
        icon: <Icon icon="local:suc-wireless-payment-credit-card-dollar" size={20} />,
      },
      {
        title: "sys.nav.system_settings",
        path: "/settings",
        icon: <Icon icon="local:suc-settings-slider-desktop-horizontal" size={20} />,
      },
      ...(GLOBAL_CONFIG.mockConfigEnabled
        ? [
            {
              title: "sys.nav.mock_configuration",
              path: "/mock-config",
              icon: <Icon icon="local:suc-settings-slider-desktop-horizontal" size={20} />,
            },
          ]
        : []),
    ],
  },
];
